// extracted by mini-css-extract-plugin
module.exports = {"box":"Buy_style_box__2Fz8L","checked":"Buy_style_checked__3G2cM","btn":"Buy_style_btn__2gU6W"};